//Bootstrap breakpoints
window.xsMin = 0;
window.xsMax = 575;
window.smMin = 576;
window.smMax = 767;
window.mdMin = 768;
window.mdMax = 991;
window.lgMin = 992;
window.lgMax = 1199;
window.xlMin = 1200;
window.xlMax = 1399;
window.xxlMin = 1400;
